import styled from "styled-components";


export const Container = styled.div`
    display: flex;
    margin-right: 30px;
    transition: 1s;
    opacity: ${(props) => (props.$visible ? '1' : '0')};
    height: ${(props) => (props.$visible ? 'auto' : '0px')};
    border-radius: 5px;
    border: 1px solid #006560;
    background: #FFF;
    box-shadow: 1px 1px 8px -10px rgba(0, 0, 0, 0.25), 1.52px 1.52px 12.5px 0px rgba(0, 0, 0, 0.25);
`;

export const Sidebar = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 10px;
    height: 150px;
    overflow: hidden;
    overflow-x: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const ContainerOption = styled.div`
    display: flex;
    align-items: center;
`;

export const RadioButton = styled.input.attrs({ type: 'radio' })`
    appearance: none;
    width: 16px;
    height: 16px;
    border: 2px solid #33CC99;
    border-radius: 50%;
    margin-right: 10px;
    position: relative;
    cursor: pointer;

    &:checked::before {
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #33CC99;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const RadioButtonLabel = styled.label`
    cursor: pointer;
    color: #333;
    font-size: 14px;
    font-style: normal;
    font-weight: ${(props) => (props.checked ? '600' : '400')};
    line-height: normal;
`;

export const Bar = styled.div`
    width: 10px;
    height: 123px;
    margin-right: 10px;
    background-image: url("data:image/svg+xml;utf8,${encodeURIComponent(
        `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="123" viewBox="0 0 10 123" fill="none"><g filter="url(#filter0_f_1244_5423)"><path d="M4.93555 4.60461V117.81" stroke="black" stroke-opacity="0.44" stroke-linecap="round"/></g><defs><filter id="filter0_f_1244_5423" x="0.435547" y="0.104614" width="9" height="122.206" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_1244_5423"/></filter></defs></svg>`
    )}");
`;